import { BaseOddCrystalsDrawer } from './BaseOddCrystalsDrawer';
import { gameMobileConfig } from '../../../core/configs';

export class OddCrystalsMobileDrawer extends BaseOddCrystalsDrawer {
  constructor() {
    super();
    this.container = null;
    this.config = {
      size: 100,
      margin: 20,
    };
  }

  setContainerPosition() {
    this.setPosition(this.container, gameMobileConfig.oddCrystalsPosition);
  }

  setOddCrystals() {
    const odds = super.getOddCrystals({parentWidth: gameMobileConfig.config.width})
    this.container.addChild(...odds);
  }

  async onLoad() {
    return this.loadResource();
  }

  async executeMainScene() {
    await this.loadResource();
    this.setContainerPosition();
    this.setOddCrystals();
    this.setOddCrystalObserver();
  }
}
